<template>
  <div class="main">
     <div id="banner" class="item">
       <el-carousel  arrow="always" height="620px" :loop="true">
         <el-carousel-item v-for="(item, index) in carouselList" :key="index">
           <img :src="item.path" alt="">
         </el-carousel-item>
       </el-carousel>
     </div>
<!--  我们能做什么  -->
    <GnPage/>
    <div id="main-two" class="item">
      <img :src=gywmPage  alt="">
      <div class="main-text">
        <div class="main-title">
          <span class="main-two-title">关于我们</span>
          <span class="text">About us</span>
        </div>
        <div class="main-middle">
          <span>优云智维西安科技有限公司《称:伏云科技),是一家专业从事将物联网和大数据应用与绿色能源的智慧能源软件产品及服务供应商,公司秉承以品质服务能源的企业精神和心价值观,聚集了众多行业内具有多年经验的志同通合的优秀人才,致力于快速满足客户需求,为客户创造最大价值而服务</span>
          <span>研发成果</span>
          <span>伏云科技在新能深领域,聚集光伏电站的智能监控和高效运维思维,基于“互联网+"的理念,利用云计算、大数据、物联网技术,自主研发推出了光伏电站智能监控整体解决方案,针对光伏电站提供了金方位的、稳定运行的、安全高效的监控整体解决方案,不断突破创新,助力光伏电站持续高效运</span>
        </div>
      </div>
    </div>
    <div id="main-three" class="item">
      <div class="three-title">
        <span class="title">主营产品</span>
        <span class="text">高端防护技术 多维度压测 保障产品安全可靠</span>
      </div>
      <div class="main-three-footer">
          <div class="main-three-item">
            <img :src=zyleftPage alt="">
            <div class="footer-text">
              <span class="title">FGZW光伏电站监控系统</span>
              <span class="text">实时监控,故障精准定位.</span>
            </div>
          </div>
        <div class="main-three-item">
          <img :src=zyrightPage alt="">
          <div class="footer-text">
            <span class="title">智能通讯管理机</span>
            <span class="text">以互联网、无线通讯为基础,专门针对光伏电站自主研发推出了基于电站全设备的数据采集、转发一体化设计的通讯管理机系列产品,降低了电站信息化建设成本,实现电站设备的互联互通,为打造智能电站奠定了坚实的基础。</span>
          </div>
        </div>
      </div>
    </div>
    <img :src=framePage alt="" id="main-img">
    <KhPage/>
    <FooterPage/>
    <div class="main-gotop">
      <div class="main-gotop-item" @click="computerTarget=!computerTarget">
        <img :src=computer1Page v-if="computerTarget" alt="">
        <img :src=computer2Page v-else-if="!computerTarget" alt="">
        <div :class="!computerTarget?'gotop-text':''">
            <span>光伏数字化</span>
            <span>运营平台</span>
        </div>
        <a href="http://175.27.193.206/" target="_blank"></a>
      </div>
      <div class="line"></div>
      <div class="main-gotop-item" @click="appTarget=!appTarget">
        <img :src=app1Page v-if="appTarget" alt="">
        <img :src=app2Page v-else-if="!appTarget" alt="">
        <div :class="!appTarget?'gotop-text':''">
          <span>下载伏云智维</span>
          <span>APP</span>
        </div>
      </div>
      <div class="line"></div>
      <div class="main-gotop-item new-item" @click="topTarget=!topTarget">
        <img :src=top1Page v-if="topTarget" alt="">
        <img :src=top2Page v-else-if="!topTarget" alt="">
        <span :class="!topTarget?'gotop-text':''">返回顶部</span>
        <a href="#index"></a>
      </div>
      <div class="download" v-show="!appTarget">
        <img :src=appPng alt="">
        <span>扫码下载APP</span>
      </div>
    </div>
  </div>
</template>

<script>
import GnPage from "@/view/GnPage";
import FooterPage from "@/view/FooterPage";
import gywmPage from "@/assets/image/gywm.png";
import xqPage from "@/assets/image/xq.png";
import zyleftPage from "@/assets/image/zyleft.png";
import zyrightPage from "@/assets/image/zyright.png";
import framePage from "@/assets/image/frame.png";
import app1Page from "@/assets/image/app1.png";
import app2Page from "@/assets/image/app2.png";
import computer1Page from "@/assets/image/computer1.png";
import computer2Page from "@/assets/image/computer2.png";
import top1Page from "@/assets/image/top1.png";
import top2Page from "@/assets/image/top2.png";
import appPng from '@/assets/image/app.jpg'
import wmPng from '@/assets/image/wm.png'
import KhPage from "@/view/KhPage";
export default {
  components:{GnPage,KhPage,FooterPage},
  data(){
    return{
      gywmPage,xqPage,zyleftPage,zyrightPage,framePage,app1Page,app2Page,computer1Page,computer2Page,top1Page,top2Page,appPng,wmPng,
      carouselList: [
        {path: require('../assets/image/banner1.png')},
        {path: require('../assets/image/banner2.png')},
      ],
      targetId:1,
      scrollTop: 0,
      appTarget:true,
      computerTarget:true,
      topTarget:true,
    }
  },
}
</script>
<style lang="scss" scoped>
.main{
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  height: calc(100vh - 80px);
  margin-top: 80px;
  overflow-x: hidden;
}
#banner{
  width: 100%;
}

#main-two{
  height: 100%;
  position: relative;
  .main-text{
    display: flex;
    width: 27%;
    flex-direction: column;
    position: absolute;
    top: 72px;
    left: 19%;
    .main-title{
      display: flex;
      width: 25%;
      flex-direction: column;
      gap: 4px;
      border-bottom: 1px solid #FFFFFF;
      padding-bottom: 16px;
      .text{
        font-family: 'PingFang SC';
        font-weight: 600;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.6);
      }
      .main-two-title{
        font-family: 'PingFang SC';
        font-weight: 600;
        font-size: 28px;
        color: #FFFFFF;
      }
    }
    .main-middle{
      display: flex;
      flex-direction: column;
      padding-top: 24px;
      padding-bottom: 40px;
      font-family: 'PingFang SC';
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #FFFFFF;
    }
    .main-footer{
      display: flex;
      width: 35%;
      justify-content: space-between;
      align-items: center;
      padding: 8px 16px;
      font-family: 'PingFang SC';
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      border: 1px solid #FFFFFF;
      img{
        width: 48px;
        height: 12px;
      }
    }
  }
}

#main-three{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  .three-title{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 64px;
    gap: 12px;
    .title{
      font-family: 'PingFang SC';
      font-weight: 600;
      font-size: 28px;
      color: #031222;
    }
    .text{
      font-family: 'PingFang SC';
      font-weight: 500;
      font-size: 14px;
      color: rgba(3, 18, 34, 0.4);
    }
  }
  .main-three-footer{
    display: flex;
    gap: 16px;
    width: 60%;
    .main-three-item{
      width: 50%;
      img{
        width: 100%;
        height: 288px;
      }
      .footer-text{
        height: 35%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 24px;
        background: #FFFFFF;
        box-shadow: 0px 12px 16px rgba(5, 88, 165, 0.1);
        border-radius: 4px;
        .title{
          font-family: 'PingFang SC';
          font-weight: 500;
          font-size: 16px;
          color: #031222;
        }
        .text{
          font-family: 'PingFang SC';
          font-weight: 400;
          font-size: 12px;
          line-height: 22px;
          color: rgba(3, 18, 34, 0.7);
        }
      }
    }
  }
}
#main-img{
  margin-top: 88px;
}

#main-footer{
  position: relative;
  .footer-text{
    width: 60%;
    position: absolute;
    top: 48px;
    left: 20%;
    .footer-top{
      display: flex;
      width: 100%;
      flex-direction: column;
      border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
      gap: 4px;
      padding-bottom: 24px;
      .footer-top-title{
        font-family: 'PingFang SC';
        font-weight: 500;
        font-size: 28px;
        color: #FFFFFF;
      }
      .footer-top-text{
        font-family: 'FF DIN Pro';
        font-weight: 500;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.6);
      }
    }
    .main-bottom{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 28px;
      .main-container{
        display: flex;
        flex-direction: column;
        gap: 12px;
        .main-container-item{
          display: flex;
          flex-direction: column;
          gap: 4px;
          .container-item{
            display: flex;
            gap: 4px;
            align-items: center;
            img{
              width: 12px;
              height: 12px;
            }
            .main-bottom-title{
              font-family: 'PingFang SC';
              font-weight: 500;
              font-size: 12px;
              //line-height: 20px;
              color: #FFFFFF;
            }
          }
        }
        .main-bottom-text{
          font-family: 'FF DIN Pro';
          font-weight: 700;
          font-size: 14px;
          //line-height: 22px;
          color: #FFFFFF;
        }
      }
      img{
        width: 694px;
        height: 160px;
      }
    }
    .main-footer-text{
      display: flex;
      justify-content: center;
      gap: 12px;
      padding-top: 48px;
      span{
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
      }
    }
  }
}
.main-gotop{
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px 6px 12px rgba(13, 67, 121, 0.1);
  border-radius: 4px;
  padding: 14px 18px;
  gap: 14px;
  position: fixed;
  top: 346px;
  right: 50px;
  z-index: 999;
  .main-gotop-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    position: relative;
    div{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    img{
      width: 32px;
      height: 32px;
    }
    span{
      font-family: 'PingFang SC';
      font-weight: 400;
      font-size: 12px;
      color: rgba(3, 18, 34, 0.7);
    }
    a{
      width: 100%;
      height: 70px;
      display: block;
      position: absolute;
      top: 0;
    }
    .gotop-text{
      color: #1187FF;
    }
  }
  .line{
    width: 130px;
    height: 1px;
    background: linear-gradient(90deg, rgba(3, 18, 34, 0) 0%, rgba(3, 18, 34, 0.2) 50.52%, rgba(3, 18, 34, 0) 100%);
  }
}
.el-backtop {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.download{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 18px 12px 12px;
  background: url("@/assets/image/ewm.png") no-repeat;
  background-size: 100% 100%;
  position: fixed;
  top: 420px;
  right: 170px;
  z-index: 999;
  img{
    width: 118px;
    height: 118px;
  }
  span{
    font-family: 'PingFang SC';
    font-weight: 400;
    font-size: 12px;
    color: rgba(3, 18, 34, 0.7);
    padding: 12px 0;
  }
}

.el-carousel {
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  /deep/ .el-carousel__indicators {// 指示器
    left: unset;
    transform: unset;
    left: 20%;
  }
  /deep/ .el-carousel__button {// 指示器按钮
    width: 6px;
    height: 6px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 3px;
  }
  /deep/ .is-active .el-carousel__button {// 指示器激活按钮
    width: 40px;
    height: 6px;
    background: #FFFFFF;
  }
}
/deep/ .el-carousel__arrow .el-carousel__arrow--left{
  background: red;
}
::v-deep .el-carousel__arrow--left{
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.4);
  top: 564px;
  left: 80%;
  border-radius: 0;
  font-size: 15px;
  color: #FFFFFF;
}
::v-deep .el-carousel__arrow--right{
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.4);
  top: 564px;
  right: 300px;
  border-radius: 0;
  font-size: 15px;
  color: #FFFFFF;
}
</style>
